export default () => typeof window.history !== 'undefined' && typeof window.history.replaceState === 'function';
